import { DotLottieReact } from "@lottiefiles/dotlottie-react"
import PropTypes from "prop-types"
import "./SpinnerComponent.css"

/**
 * Componente de spinner personalizable para indicar estados de carga
 * @param {Object} props - Propiedades del componente
 * @param {string} props.size - Tamaño del spinner ('small', 'medium', 'large', o valor personalizado)
 * @param {string} props.text - Texto opcional para mostrar debajo del spinner
 * @param {string} props.color - Color del texto (si se proporciona)
 * @param {string} props.animation - URL de la animación Lottie (opcional)
 * @param {string} props.overlay - Si debe mostrarse como overlay sobre el contenido
 * @param {string} props.className - Clases CSS adicionales
 */
export default function SpinnerLoading({
  size = "medium",
  text,
  color = "#3f51b5",
  animation = "https://lottie.host/a561e4d0-8356-486c-bd04-bedf624d7080/XDLAEWMcx5.lottie",
  overlay = false,
  className = "",
}) {
  // Determinar el tamaño del spinner
  const getSpinnerSize = () => {
    if (size === "small") return "spinner-small"
    if (size === "medium") return "spinner-medium"
    if (size === "large") return "spinner-large"
    return "spinner-custom"
  }

  // Determinar la clase del contenedor
  const containerClass = overlay ? "containerSpinner containerSpinner-overlay" : "containerSpinner"

  return (
    <div className={`${containerClass} ${className}`} role="status" aria-live="polite">
      <div className="spinner-content">
        <DotLottieReact
          className={`spinner ${getSpinnerSize()}`}
          src={animation}
          loop
          autoplay
          style={size !== "small" && size !== "medium" && size !== "large" ? { width: size, height: size } : {}}
        />

        {text && (
          <p className="spinner-text" style={{ color }}>
            {text}
          </p>
        )}

        <span className="sr-only">Cargando...</span>
      </div>
    </div>
  )
}

SpinnerLoading.propTypes = {
  size: PropTypes.string,
  text: PropTypes.string,
  color: PropTypes.string,
  animation: PropTypes.string,
  overlay: PropTypes.bool,
  className: PropTypes.string,
}

